import { SimpleEvent } from '@eastsideco/salvo-ts';
import { BaseCart } from './cart/BaseCart';

export default class Cart extends BaseCart {

    private interactionDepth = 0;

    private _onChangeByInteraction = new SimpleEvent<void>();
    public get onChangeByInteraction() {
        return this._onChangeByInteraction.asEvent();
    }

    private _onTransactedChange = new SimpleEvent<void>();
    public get onTransactedChange() {
        return this._onTransactedChange.asEvent();
    }

    private _onLoaded = new SimpleEvent<void>();
    public onLoad(func: (cart: Cart) => void) {
        if(this.loaded) {
            return func(cart);
        }
        this._onLoaded.subscribe(() => {
            func(cart);
        });
    }

    private loaded = false;

    constructor() {
        super();

        this.reload()
            .catch((event: unknown | null) => {
                if (event instanceof Error) {
                    console.error(event.message);
                }
            })
            .then(() => {
                this.loaded = true;
                this._onLoaded.dispatch();
            });

        this.onChange.subscribe(() => {
            if (this.interactionDepth > 0 || !this.loaded) {
                return;
            }
            this._onTransactedChange.dispatch();
        });
    }



    async asInteraction<T = void>(cb: () => T): Promise<T> {
        try {
            this.interactionDepth++;
            const r = await cb();
            this._onChangeByInteraction.dispatch();
            this._onTransactedChange.dispatch();
            return r;
        } finally {
            this.interactionDepth--;
        }
    }

    isEmpty() {
        return cart.items.length <= 0;
    }

    public getCartItemCount() {
        let itemCount = 0;
        for (const item of cart.items) {
            if (
                Number(item.properties._display_quantity) &&
                item.properties._display_quantity !== '' &&
                Number(item.properties._display_quantity) > 1) {
                const itemQuantity = item.quantity / Number(item.properties._display_quantity);
                itemCount += itemQuantity;
            } else {
                itemCount += item.quantity;
            }
        }
        return itemCount;
    }

    getCartItemByPropertyKey(key: string) {
        return cart.items.find((item) => item.properties[key]);
    }
}


export const cart = new Cart();
